import styled, { css } from 'styled-components'
import { tabletBreakpoint } from 'react-components'

import { FilterHeadPosition } from '../types'

export const FilterContainer = styled.div<{ filterHeadPosition?: FilterHeadPosition }>`
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        position: relative;

        ${({ filterHeadPosition }) =>
            filterHeadPosition === FilterHeadPosition.MOBILE_FILTER &&
            css`
                border-bottom: 0.5rem solid #f2f2f2;
                padding: 1rem;

                &:last-child {
                    border-bottom: none;
                }
            `}
    }

    @media only screen and (max-width: ${tabletBreakpoint.min}px) {
        border-bottom: 0.5rem solid #f2f2f2;
        padding-top: 1rem;

        &:last-child {
            border-bottom: none;
        }
    }
`
export const FilterContentContainer = styled.div<{
    filterHeadPosition?: FilterHeadPosition
    isMultiple?: boolean
    isPriceFilter?: boolean
}>(
    ({ filterHeadPosition, isMultiple, isPriceFilter, theme }) => css`
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            display: none;
            position: absolute;
            top: 2.5rem;
            z-index: 1;
            left: 1.25rem;
            ${isMultiple || isPriceFilter ? 'min-width: 26.25rem;' : 'min-width: 15.625rem;'}
            background-color: ${theme.colors.white};
            border: ${theme.typography.border.radius.xxxSmall} solid #0000001a;
            box-sizing: border-box;
            box-shadow: 0 8px 10px #0000000f, 0 3px 14px #0000000a, 0 5px 5px #00000014;
            border-radius: ${theme.typography.border.radius.small};
            ${filterHeadPosition === FilterHeadPosition.MORE_FILTER &&
            css`
                display: flex;
                position: relative;
                top: unset;
                left: unset;
                border: 0;
                box-shadow: unset;
                width: ${theme.layout.fill};
            `}

            ${filterHeadPosition === FilterHeadPosition.STANDARD_FILTER_LISTING &&
            css`
                display: block;
                position: relative;
                top: unset;
                left: unset;
                border: 0;
                box-shadow: unset;
                width: ${theme.layout.fill};
                min-width: unset;
            `}
            ${filterHeadPosition === FilterHeadPosition.MOBILE_FILTER &&
            css`
                display: block !important;
                position: relative;
                top: unset;
                left: unset;
                border: 0;
                box-shadow: unset;
                width: ${theme.layout.fill};
                min-width: unset;
            `}
        }

        @media only screen and (max-width: ${tabletBreakpoint.min}px) {
            padding: 0 1rem;
        }
    `,
)

export const StyledFilterContent = styled.div<{ filterHeadPosition?: FilterHeadPosition }>(
    ({ filterHeadPosition, theme }) => css`
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.medium};
            user-select: none;
            width: ${theme.layout.fill};
            padding: ${filterHeadPosition === FilterHeadPosition.STANDARD_FILTER_LISTING
                ? '0.25rem 0 0 0'
                : filterHeadPosition === FilterHeadPosition.MOBILE_FILTER
                ? '0'
                : `${theme.spacing.large} ${theme.spacing.large} ${theme.spacing.xSmall}`};
        }
    `,
)
